/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Errors_Failedtoload2Inputs */

const he_posts_errors_failedtoload2 = /** @type {(inputs: Posts_Errors_Failedtoload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`טעינת הפוסטים נכשלה`)
};

const en_posts_errors_failedtoload2 = /** @type {(inputs: Posts_Errors_Failedtoload2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load posts`)
};

/**
* | output |
* | --- |
* | "Failed to load posts" |
*
* @param {Posts_Errors_Failedtoload2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_errors_failedtoload2 = /** @type {((inputs?: Posts_Errors_Failedtoload2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Errors_Failedtoload2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_errors_failedtoload2(inputs)
	return en_posts_errors_failedtoload2(inputs)
});
export { posts_errors_failedtoload2 as "posts_errors_failedToLoad" }